export default {
  details: {
    editableBlock: '',
    general: {},
  },
};
